import { useEffect } from 'react'

import { logout } from 'lib/authentication/Logout'
import { terminateUserSession } from 'lib/Helper'
import { useAppSelector } from 'redux/Hook'
import heartbeatAPI from 'api/ApiActions/Common/Heartbeat'
import { HTTP_STATUS } from 'lib/GlobalConstants'
import { isDevelopment } from 'lib/utility/ApplicationConfig'
import { isStackholderDashboardUrl } from 'lib/HooksHelper'

function useValidateUserSession(
  location: {
    pathname: string
    search: string
  },
  // This functions saves the flicker in screen as user jumps from one admin-ui module to other
  setIsActiveUser: (arg0: boolean) => void,
) {
  const site = useAppSelector((state) => state.site.site)
  const checkAccess = async () => {
    const response = await heartbeatAPI.getUnexpectedVisitCookie()
    if (response.status !== HTTP_STATUS.noContentSuccessStatus) {
      setIsActiveUser(false)
      return await terminateUserSession(logout, site)
    }
    return setIsActiveUser(true)
  }

  useEffect(() => {
    if (isStackholderDashboardUrl(location) || isDevelopment()) {
      setIsActiveUser(true)
    } else {
      checkAccess()
    }
  }, [location])
}

export default useValidateUserSession
